// export const supportChatListeners = (socket, dispatch) => {
//   const handler = (data) => {
//     dispatch({ type: "supportChat/addSocketMessage", payload: data });
//   };

//   socket.off("supportChat:newMessage", handler);
//   socket.on("supportChat:newMessage", handler);

//   console.log(
//     "Listeners for supportChat:newMessage",
//     socket.listeners("supportChat:newMessage").length
//   );
// };

const listenerRegistry = new WeakMap();

export const supportChatListeners = (socket, dispatch) => {
  if (listenerRegistry.has(socket)) {
    socket.off("supportChat:newMessage", listenerRegistry.get(socket));
  }

  const handler = (data) => {
    dispatch({ type: "supportChat/addSocketMessage", payload: data });
  };

  socket.on("supportChat:newMessage", handler);
  listenerRegistry.set(socket, handler);

  // console.log(
  //   "Listeners for supportChat:newMessage",
  //   socket.listeners("supportChat:newMessage").length
  // );
};
